import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBookLinks, getPrimaryNavLinks, getSecondaryNavLinks } from './navlinks';
var enPrimaryNav = getPrimaryNavLinks(['Study', 'Tasks', 'Homework help', 'Understand a topic', 'Writing & citations', 'Tools', 'Expert Q&A', 'Textbook Solutions', 'Math Solver', 'Citations', 'Plagiarism checker', 'Grammar checker', 'Expert proofreading', 'Career', 'Bootcamps', 'Career advice', 'Learning Lab']);
var enSecondaryNav = getSecondaryNavLinks(['For educators', 'Help', 'Sign in']);
var enBooks = getBookLinks(['Books', 'Rent/Buy', 'Read', 'Return', 'Sell']);
export var englishContentIntl = {
  PrimaryNav: enPrimaryNav,
  SecondaryNav: enSecondaryNav,
  experimentIds: []
};
export var englishContentUS = {
  PrimaryNav: [enBooks].concat(_toConsumableArray(enPrimaryNav)),
  SecondaryNav: enSecondaryNav,
  experimentIds: []
};